import { t } from "@lingui/core/macro";
import { useLingui } from "@lingui/react";
import { Box, Typography } from "@mui/material";
import { usePickerContext } from "@mui/x-date-pickers/hooks";
import { format } from "date-fns";
import { getDateFnsLocale } from "@/utils/booking";

export default function CustomCalendarHeader() {
  const { value, view, setView } = usePickerContext();
  const { i18n } = useLingui();
  const locale = getDateFnsLocale(i18n.locale);
  const date = value || new Date();

  const renderLabel = (text: string, onClick?: () => void) => (
    <Typography
      variant="subtitle1"
      fontWeight={600}
      color={onClick ? "text.primary" : "text.secondary"}
      sx={onClick ? { cursor: "pointer" } : undefined}
      onClick={onClick}
    >
      {text}
    </Typography>
  );

  return (
    <Box sx={{ display: "flex", justifyContent: "start", gap: 1, px: 2.5, py: 1, mt: 1 }}>
      {view === "year" && renderLabel(t`Please select a year`)}
      {view === "month" && renderLabel(t`Please select a month`)}
      {view === "day" && (
        <>
          {renderLabel(format(date, "MMMM", { locale }), () => setView("month"))}
          {renderLabel(format(date, "yyyy"), () => setView("year"))}
        </>
      )}
    </Box>
  );
}
